/* Washpico theme JS — no dependencies */
(function () {
  'use strict';

  /* mobile nav */
  var burger = document.querySelector('[data-burger]');
  if (burger) {
    burger.addEventListener('click', function () {
      var nav = document.querySelector('[data-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* product gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gal-main]');
    gal.querySelectorAll('[data-gal-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (main && src) main.setAttribute('src', src);
        gal.querySelectorAll('[data-gal-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });
      });
    });
  });

  /* variant selection */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data = null;
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var btn = root.querySelector('[data-add]');
    var money = root.getAttribute('data-money-format') || '${{amount}}';

    function fmt(cents) {
      var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
    }
    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-opt-group]'), function (g) {
        var on = g.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function sync() {
      var want = selected();
      var match = data.find(function (v) {
        return want.every(function (o, i) { return o === null || v.options[i] === o; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = fmt(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      }
    }
    root.querySelectorAll('[data-opt-group]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.vopt'); if (!b) return;
        g.querySelectorAll('.vopt').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        sync();
      });
    });
    sync();
  });

  /* quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !input) return;
      var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = next;
    });
  });
})();

/* Highlight any leftover "TODO —" copy so it cannot ship by accident.
   Delete this block once every TODO in the theme editor has been replaced. */
(function(){
  var RX = /TODO\s*[—-]/;
  function mark(root){
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(n){
        if(!RX.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if(!p || p.closest('.todo, .todobox, script, style')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var hits = [], n;
    while((n = w.nextNode())) hits.push(n);
    hits.forEach(function(node){
      var s = document.createElement('span');
      s.className = 'todo';
      node.parentNode.replaceChild(s, node);
      s.appendChild(node);
    });
  }
  if(document.readyState !== 'loading') mark(document.body);
  else document.addEventListener('DOMContentLoaded', function(){ mark(document.body); });
  document.addEventListener('shopify:section:load', function(e){ mark(e.target); });
})();
